import { createSelector } from 'reselect'
import { formIdFromAnswersHubSelector } from './hub'
import { RootState } from '../types/rootstate'
import { currentParamsSelector } from './navigation'

const articlesDetailsSelector = (state: RootState) => state.articleDetails

export const currentAnswersArticleFromParamsDetailsSelector = createSelector(
  [ articlesDetailsSelector, currentParamsSelector ],
  (articleDetails, params) => {
    const item = articleDetails[params.answersId]
    return (item && item.article) || {}
  }
)

export const currentAnswersArticlesDetailsFromParamsStatusSelector = createSelector(
  [ articlesDetailsSelector, currentParamsSelector ],
  (articleDetails, params) => {
    const item = articleDetails[params.answersId]
    return (item && item.status) || 'none'
  }
)
